import { ErrorPage } from '@/pages/Layout/pages';
import { RouteObject } from 'react-router-dom';
import { Authorize } from '@/components';
import { lazy } from 'react';
import {
  BUSINESS_ROLE_GROUPS,
  EXTERNAL_OPERATOR_ROLE_GROUPS,
} from '@/components/security/AppRoles';

const TimeSlots = lazy(() => import('../TimeSlots'));

const ADMIN_PERMISSIONS = [
  ...BUSINESS_ROLE_GROUPS.operations,
  ...EXTERNAL_OPERATOR_ROLE_GROUPS.admin,
];

const TimeSlotsRoutes: RouteObject[] = [
  {
    path: 'logistics-management/time-slots',
    element: (
      <Authorize
        permission={ADMIN_PERMISSIONS}
        fallback={<ErrorPage code={403} />}
      >
        <TimeSlots />
      </Authorize>
    ),
  },
];

export default TimeSlotsRoutes;
